import { Autocomplete, Paper, TextField, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { PatientCustomReminderSchedule } from '../../../../../../../../services/api-client/contact-api';

const AppointmentSectionContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: '20px',
  borderBottom: '1px solid #E1E4E7'
});

const AppointmentHeader = styled(Typography)({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: '500',
  fontSize: '16px',
  lineHeight: '20px',
  color: '#000000'
});

const Dropdown = styled(Autocomplete)({
  width: '100%',
  marginTop: '8px'
});

const DropDownText = styled(TextField)({
  display: 'flex',
  alignItems: 'center',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '24px',
  color: '#000000'
});

interface AppointmentSectionProps {
  header: string;
  preference: PatientCustomReminderSchedule;
  onChange: (value: PatientCustomReminderSchedule) => void;
  className?: string;
}

const AppointmentSection = ({ header, preference, onChange, className }: AppointmentSectionProps) => {
  const options: PatientCustomReminderSchedule[] = [
    PatientCustomReminderSchedule.Global,
    PatientCustomReminderSchedule.On,
    PatientCustomReminderSchedule.Off
  ];

  const DropDownPaper = (props: React.HTMLAttributes<HTMLElement>) => {
    return <Paper elevation={8} style={{ background: '#FFFFFF' }} {...props} />;
  };

  return (
    <AppointmentSectionContainer className={`appointment-section-container ${className}`}>
      <AppointmentHeader className="appointment-header" variant="h5">
        {header}
      </AppointmentHeader>
      <Dropdown
        autoComplete={false}
        disableClearable
        PaperComponent={DropDownPaper}
        disablePortal
        defaultValue={preference}
        size="small"
        id="appointment-reminder-dropdown"
        options={options}
        // @ts-ignore
        onChange={(item, value) => onChange(value)}
        renderInput={(params) => <DropDownText {...params} variant="outlined" />}
      />
    </AppointmentSectionContainer>
  );
};

export default AppointmentSection;
